'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.forecast',
dependencies:['ui.router'],
configs:[
require('./forecastConfig')],

components:[
require('./forecastController')]});
//# sourceMappingURL=index.js.map
